(function () {
  // var params = new URLSearchParams(window.location.search);
  // var isTestPreview = params.get('test_preview') === 'true';

  var isCartPage = window.location.pathname === '/cart';

  // ─── 商品ページ：カートボタンをフック ───
  if (!isCartPage) {
    // if (!isTestPreview) return;

    document.addEventListener('DOMContentLoaded', function () {
      var addButtons = document.querySelectorAll(
        'form[action="/cart/add"] [type="submit"], ' +
        'form[action="/cart/add"] button:not([type="button"])'
      );

      addButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var returnUrl = window.location.href;

            fetch('/cart.js')

            .then(function (res) { return res.json(); })
            .then(function (cartBefore) {
              var countBefore = cartBefore.item_count;
              var tries = 0;
              var interval = setInterval(function () {
                tries++;
                fetch('/cart.js')
                  .then(function (res) { return res.json(); })
                  .then(function (cartAfter) {
                    if (cartAfter.item_count !== countBefore || tries > 20) {
                      clearInterval(interval);
                      if (cartAfter.item_count !== countBefore) {
                        var item = cartAfter.items[0];
                        // 汎用フォーマットで保存
                        sessionStorage.setItem('cart_popup_data', JSON.stringify({
                          type: 'cart_added',
                          return_url: returnUrl,
                          image: item.image || '',
                          title: item.product_title || item.title,
                          variant: (item.variant_title && item.variant_title !== 'Default Title')
                            ? item.variant_title.replace(/\s*\/\s*/g, ', ') : '',
                          price: Math.round(item.final_price / 100)
                        }));
                        // カートページへ遷移
                        window.location.href = '/cart';
                      }
                    }
                  });
              }, 300);
            });
        });
      });
    });

  // ─── カートページ：ポップアップ表示 ───
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      var raw = sessionStorage.getItem('cart_popup_data');
      if (!raw) return;

      var data = JSON.parse(raw);
      sessionStorage.removeItem('cart_popup_data'); // 再表示防止

      // 同じストアの商品ページだけを戻り先として許可する。
      var continueButton = document.getElementById('cart-popup-continue');

      if (continueButton && data.return_url) {
        try {
          var returnTarget = new URL(
            data.return_url,
            window.location.origin
          );

          var isSameStore =
            returnTarget.origin === window.location.origin;

          var isProductPage =
            /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+\/)?products\/[^/]+\/?$/i
              .test(returnTarget.pathname);

          if (isSameStore && isProductPage) {
            continueButton.href =
              returnTarget.pathname +
              returnTarget.search +
              returnTarget.hash;
          }
        } catch (error) {
          console.warn('カートモーダルの戻り先を設定できませんでした。', error);
        }
      }

      // ポップアップに値を流し込む
      document.getElementById('cart-popup-image').src = data.image;
      document.getElementById('cart-popup-title').textContent = data.title;
      document.getElementById('cart-popup-variant').textContent = data.variant;
      document.getElementById('cart-popup-price-value').textContent =
        data.price.toLocaleString('ja-JP');

      document.getElementById('cart-added-popup').style.display = 'block';
    });
  }

  // ─── 閉じるボタン（全ページ共通） ───
  function closeCartPopup(e) {
    if (e && e.target !== document.getElementById('cart-added-popup')) return;
    document.getElementById('cart-added-popup').style.display = 'none';
  }
  window.closeCartPopup = closeCartPopup;

})();
